import speakerChatroomState from "./speakerChatroom/state"
// console.log(speakerChatroomState, "123432324234242")
export default {
  lang: "cn",
  current_event: {},
  user_info: {},
  ping_interval: {},
  ajax_spin_count: 0,
  current_session_id: null,
  current_session_status: false,
  current_role: '',
  current_event_id:'',
  helper_roles:null,
  event:{},
  isRegister: false,
  assistant_temp_session:null,
  unread_notice_list: [],
  // is_show
  // ...speakerChatroomState,
  data: {
    version:"",
    classNum: "",// 教室号
    userName: '',// 用户名
    userId:null,// userId
    role: null,// 角色
    client: null,// rtc 实例
    isShowSetting: false,// 是否显示配置项
    isPublish:false,
    isPreview:false,
    isPublishScreen:false, //屏幕分享
    isSwitchScreen:false,// 是否切换大小流
    switchUserId:"",
    userList:[],
    supportInfo:{},
    channel_list: []
  },
  //网站基础数据
  config: {

  },
  place_map:{},
  user_identify:{},
  current_identify:''
}



// WEBPACK FOOTER //
// ./src/store/state.js